import { render, staticRenderFns } from "./DynamicMailStorage.vue?vue&type=template&id=71335c91&scoped=true&"
import script from "./DynamicMailStorage.vue?vue&type=script&lang=js&"
export * from "./DynamicMailStorage.vue?vue&type=script&lang=js&"
import style0 from "./DynamicMailStorage.vue?vue&type=style&index=0&id=71335c91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71335c91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VContainer})
